import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import $ from 'jquery';

class Hero {
	constructor() {
		var self = this;
		this.swiper_hero = null;

		this.init();

		if ($('.hero-container .swiper-container').length) {
			self.updateSlider();

			$(window).on('resize', function () {
				self.updateSlider();
			});
		}
	}

	updateSlider() {
		var self = this;

		if ($('.hero-container').length) {
			var viewportWidth = $(window).width();

			$('.hero-container .swiper-wrapper .swiper-slide').each(function (e) {
				var $swiper = $(this);

				if (viewportWidth <= 560) {
					var mobileImage = $swiper.data('mobile-img');

					if (mobileImage) {
						$swiper.css("background-image", "url(" + mobileImage + ")");
					}
				} else {
					var desktopImage = $swiper.data('desktop-img');
					$swiper.css("background-image", "url(" + desktopImage + ")");
				}
			});

			self.swiper_hero.update();
		}
	}

	init() {
		SwiperCore.use([Navigation, Pagination]);

		const swiper_hero_elem = '.hero-container .swiper-container';

		// Hero
		this.swiper_hero = new Swiper(swiper_hero_elem, {
			slidesPerView: 1,
			autoHeight: true,
			spaceBetween: 0,
			speed: 1500,
			autoplay: {
				delay: 5000
			},
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		});

		this.swiper_hero.on('slideChange', function (swiper) {
			var $swiper_container = $(swiper_hero_elem).parent();
			var index = swiper.realIndex + 1;

			$swiper_container.parent().find('.mobile-container .slide').removeClass('d-none').addClass('d-none');
			$swiper_container.parent().find('.mobile-container .slide-' + index).removeClass('d-none');
		});
	}
}

export default Hero;
